import rpc from "@/rpc";

class UserService {
    rpc

    constructor(rpc) {
        this.rpc = rpc
    }

    createUser(data) {
        return this.rpc.execute('createUser', data);
    }
}

export default new UserService(rpc)
